<template>
  <div>

    <v-dialog
    v-model="error"
    width="500"
    >

      <v-card>
        <v-card-title
          class="headline red accent-3"
          primary-title
        >
          Warning Message
        </v-card-title>

        <v-card-text>
          {{errorMsg}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red accent-3"
            flat
            @click="setErrorZero"
          >
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-toolbar flat color="white">
      <v-toolbar-title>Investee All Data</v-toolbar-title>
     <v-spacer></v-spacer>
       <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
        
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px">
        <!-- <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">New Investee All Data</v-btn>
        </template> -->
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.title" label="Investee All Data Name"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="indexData.data"
      :search="search"
      :pagination.sync="pagination"
      :rows-per-page-items="rowsPerPageItems"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.id }}</td>
        <td class="text-xs-center">{{ props.item.name }}</td>
        <td class="text-xs-center">{{ props.item.phone }}</td>
        <td class="text-xs-center">{{ props.item.email }}</td>
        <td class="text-xs-center">{{ (props.item.photo) ? 'yes' : 'no' }}</td>
        <td class="text-xs-center">{{ (props.item.active)? 'yes' : 'no' }}</td>
        <td class="text-xs-center">{{ props.item.created_at }}</td>
        <td class="text-xs-center">{{ props.item.basic_info.present_address }}</td>
        <td class="text-xs-center">{{ props.item.division_name }}</td>
        <td class="text-xs-center">{{ props.item.district_name }}</td>
        <td class="text-xs-center">{{ (props.item.basic_info.dob)? (props.item.basic_info.dob) : 'no' }}</td>
        <td class="text-xs-center">{{ (props.item.basic_info.gov_id_no)? (props.item.basic_info.gov_id_no) : 'no' }}</td>
        <td class="text-xs-center">{{ (props.item.gender)? (props.item.gender) : 'no' }}</td>
        <td class="text-xs-center">{{ (props.item.marital_status)? (props.item.marital_status) : 'no' }}</td>
        <td class="text-xs-center">{{ (props.item.employment_type)? (props.item.employment_type) : 'no' }}</td>
        <td class="text-xs-center">{{ (props.item.monthly_income)? (props.item.monthly_income) : 'no' }}</td>
        <td class="text-xs-center">{{ (props.item.educational_qualification)? (props.item.educational_qualification) : 'no' }}</td>
        <td class="text-xs-center">{{ (props.item.institute_name)? (props.item.institute_name) : 'no' }}</td>
        <td class="text-xs-center">{{ (props.item.out_loan_availability)? 'yes' : 'no' }}</td>
        <td class="text-xs-center">{{ (props.item.bank_detail)? (props.item.bank_detail.bank_name) : 'no' }}</td>
        <td class="text-xs-center">{{ (props.item.bank_detail)? (props.item.bank_detail.receiver_name) : 'no' }}</td>
        <td class="text-xs-center">{{ (props.item.bank_detail)? (props.item.bank_detail.account_no) : 'no' }}</td>
        <td class="text-xs-center">{{ (props.item.account_type)? (props.item.account_type) : 'no' }}</td>
        <td class="text-xs-center">{{ (props.item.photo)? (props.item.photo) : 'no' }}</td>
        <td class="text-xs-center">{{ (props.item.document)? (props.item.document.nid_front_page) : 'no' }}</td>
        <td class="text-xs-center">{{ (props.item.document)? (props.item.document.nid_back_page) : 'no' }}</td>
        <td class="text-xs-center">{{ (props.item.document)? (props.item.document.birth_certificate) : 'no' }}</td>
        <td class="text-xs-center">{{ (props.item.document)? (props.item.document.other_gov_issued_id) : 'no' }}</td>
        <td class="text-xs-center">{{ (props.item.document)? (props.item.document.salary_certificate) : 'no' }}</td>
        <td class="text-xs-center">{{ (props.item.document)? (props.item.document.bank_statement_first_page) : 'no' }}</td>
        <td class="text-xs-center">{{ (props.item.document)? (props.item.document.bank_statement_last_page) : 'no' }}</td>
        <td class="text-xs-center">{{ (props.item.document)? (props.item.document.electricity_bill) : 'no' }}</td>
        <td class="text-xs-center">{{ (props.item.document)? (props.item.document.additional_document1) : 'no' }}</td>
        <td class="text-xs-center">{{ (props.item.document)? (props.item.document.additional_document2) : 'no' }}</td>
        <td class="text-xs-center">{{ (props.item.document)? (props.item.document.additional_document3) : 'no' }}</td>
        <!-- <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(props.item)"
          >
            delete
          </v-icon>
        </td> -->
      </template>
      <template v-slot:pageText>
      Rows {{ indexData.from }} - {{ indexData.to }} of {{ indexData.total }}
    </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
    <template>
      <div class="text-xs-center">
        <v-pagination
          v-model="indexData.current_page"
          :length="indexData.last_page"
          @input="onPageChange"
        ></v-pagination>
      </div>
    </template>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'

 export default {
    data: () => ({
      dialog: false,
      search: '',
      apiUrl: 'investee-all-data',
      headers: [
        { text: 'ID', align: 'center', sortable: true, value: 'id'},
        { text: 'Name', align: 'center', sortable: true, value: 'name'},
        { text: 'Phone', align:'center',value: 'phone' },
        { text: 'Email', align:'center',value: 'email' },
        { text: 'Photo', align:'center',value: 'photo' },
        { text: 'Active', align:'center',value: 'active' },
        { text: 'Registration Date', align:'center',value: 'created_at' },
        { text: 'address', align:'center',value: 'address' },
        { text: 'Division', align:'center',value: 'division' },
        { text: 'District', align:'center',value: 'district' },
        { text: 'Birth Date', align:'center',value: 'dob' },
        { text: 'nid', align:'center',value: 'gov_id_no' },
        { text: 'gender', align:'center',value: 'gender' },
        { text: 'marital-status', align:'center',value: 'marital-status' },
        { text: 'employment-type', align:'center',value: 'employment-type' },
        { text: 'monthly_income', align:'center',value: 'monthly_income' },
        { text: 'educational_qualification', align:'center',value: 'educational_qualification' },
        { text: 'institute_name', align:'center',value: 'institute_name' },
        { text: 'out_loan_availability', align:'center',value: 'out_loan_availability' },
        { text: 'bank_name', align:'center',value: 'bank_name' },
        { text: 'receiver_name', align:'center',value: 'receiver_name' },
        { text: 'account_no', align:'center',value: 'account_no' },
        { text: 'account_type', align:'center',value: 'account_type' },
        { text: 'photo', align:'center',value: 'photo' },
        { text: 'nid_front', align:'center',value: 'nid_front' },
        { text: 'nid_back', align:'center',value: 'nid_back' },
        { text: 'birth_certificate', align:'center',value: 'birth_certificate' },
        { text: 'other_gov_issued_id', align:'center',value: 'other_gov_issued_id' },
        { text: 'salary_certificate', align:'center',value: 'salary_certificate' },
        { text: 'bank_statement_first_page', align:'center',value: 'bank_statement_first_page' },
        { text: 'bank_statement_last_page', align:'center',value: 'bank_statement_last_page' },
        { text: 'electricity_bill', align:'center',value: 'electricity_bill' },
        { text: 'additional_document1', align:'center',value: 'additional_document1' },
        { text: 'additional_document2', align:'center',value: 'additional_document2' },
        { text: 'additional_document3', align:'center',value: 'additional_document3' },
        // { text: 'Actions', align:'center',value: 'actions' },
      ],
      loading: false,
      pagination: {},
      rowsPerPageItems: [20, 50, 100, 200, 500],
      editedIndex: -1,
      editedItem: {
        title: ''
      },
      defaultItem: {
       title: ''
      }
    }),

    computed: {
      ...mapGetters(['isLoggedIn', 'indexData', 'error', 'statusCode', 'errorMsg', 'investorAgreement', 'investeeAgreement', 'userImage', 'docImage']),
      formTitle () {
        return this.editedIndex === -1 ? 'New Investee All Data' : 'Edit Investee All Data'
      },
    },

    watch: {
      pagination() {
            this.paginationMethod()
      },
      dialog (val) {
        val || this.close()
      },
      
    },

    created () {
      // this.initialize()
    },

    methods: {
      initialize () {
        this.paginationMethod()
      },

       setErrorZero () {
        this.$store.dispatch('setErrorZero')
      },

      editItem (item) {
        this.editedIndex = this.indexData.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.indexData.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.indexData.splice(index, 1)
        this.$store.dispatch('delete', [this.apiUrl, item.id])
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          this.$store.dispatch('store', [this.apiUrl, this.editedItem])
        } else {
          this.$store.dispatch('store', [this.apiUrl, this.editedItem])
        }
        this.close()
      },
      onPageChange(){
        this.paginationMethod()
      },

      paginationMethod() {
            this.loading = true
            
            if(this.search){
              this.$store.dispatch('getPaginatedIndexData', [this.apiUrl, this.search, this.indexData.current_page, this.pagination.rowsPerPage])
              this.loading = (this.indexData.data) ? false : true
            }else{
              this.$store.dispatch('getPaginatedIndexData', [this.apiUrl, this.search, this.indexData.current_page, this.pagination.rowsPerPage])
              this.loading = (! this.indexData.error) ? false : true
            }
      },
    }
  }
</script>